import { ref, onMounted, onUnmounted } from 'vue';

export function useMobileDetect(callback?: (isMobile: boolean) => void) {
    const isMobile = ref(false);

    function checkScreenSize() {
        // 判断屏幕宽度是否 ≤ 768px（常见移动端断点）
        const val = window.innerWidth <= 768;
        if (val != isMobile.value) {
            callback && callback(val);
        }
        isMobile.value = val;
    }

    onMounted(() => {
        checkScreenSize(); // 初始化检测
        window.addEventListener('resize', checkScreenSize); // 监听窗口变化
    });

    onUnmounted(() => {
        window.removeEventListener('resize', checkScreenSize); // 清除监听
    });

    return { isMobile };
}